import React, { useEffect, useState } from 'react';

/*
  SocialAuthButtons — "Continue with Google / Microsoft" buttons.
  Only renders providers that the backend reports as configured, so no broken
  buttons appear before OAuth credentials are set. Clicking navigates to the
  server-side start endpoint, which redirects to the provider's consent screen.
*/

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
    <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z" />
    <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z" />
    <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33z" />
    <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.47.9 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z" />
  </svg>
);

const MicrosoftIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
    <rect width="7" height="7" x="0" y="0" fill="#F25022" />
    <rect width="7" height="7" x="9" y="0" fill="#7FBA00" />
    <rect width="7" height="7" x="0" y="9" fill="#00A4EF" />
    <rect width="7" height="7" x="9" y="9" fill="#FFB900" />
  </svg>
);

const META = {
  google:    { label: 'Continue with Google',    Icon: GoogleIcon },
  microsoft: { label: 'Continue with Microsoft', Icon: MicrosoftIcon },
};

const SocialAuthButtons = () => {
  const [providers, setProviders] = useState(null);

  useEffect(() => {
    let alive = true;
    fetch('/api/auth/providers')
      .then((r) => (r.ok ? r.json() : {}))
      .then((d) => { if (alive) setProviders(d || {}); })
      .catch(() => { if (alive) setProviders({}); });
    return () => { alive = false; };
  }, []);

  if (!providers) return null;
  const active = ['google', 'microsoft'].filter((p) => providers[p]);
  if (active.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
      {active.map((p) => {
        const { label, Icon } = META[p];
        return (
          <button
            key={p}
            type="button"
            onClick={() => { window.location.href = `/api/auth/${p}`; }}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
              width: '100%', padding: '11px 14px', borderRadius: '8px',
              border: '1px solid var(--border)', backgroundColor: 'var(--bg)',
              color: 'var(--text-primary)', fontSize: '14px', fontWeight: 600,
              cursor: 'pointer', fontFamily: 'inherit', transition: 'border-color 0.2s, background-color 0.2s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'var(--text-tertiary)'; e.currentTarget.style.backgroundColor = 'var(--bg-secondary)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.backgroundColor = 'var(--bg)'; }}
          >
            <Icon />
            {label}
          </button>
        );
      })}

      {/* OR divider */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '4px 0' }}>
        <div style={{ flex: 1, height: '1px', backgroundColor: 'var(--border)' }} />
        <span style={{ fontSize: '12px', color: 'var(--text-tertiary)', fontWeight: 500 }}>OR</span>
        <div style={{ flex: 1, height: '1px', backgroundColor: 'var(--border)' }} />
      </div>
    </div>
  );
};

export default SocialAuthButtons;
